import getIncludedResource from '../../../helpers/getIncludedResource';

export const getSchemeIds = (schemes, isSchemeGroup, included, status) => {
  if (!Array.isArray(schemes)) {
    return [];
  }
  const schemeIds = schemes
    .filter((scheme) => (status ? status.includes(scheme.attributes.status) : true))
    .map((scheme) => scheme.id);
  if (!isSchemeGroup) {
    return schemeIds;
  }
  const schemeGroupIds = schemes.reduce((carry, scheme) => {
    if (scheme.attributes.status !== 'test') {
      return carry;
    }
    const schemeGroup = getIncludedResource(scheme, included, 'scheme_group');
    const schemeGroupId = schemeGroup.data.id;
    if (carry[schemeGroupId]) {
      return carry;
    }
    carry.push(schemeGroupId);
    return carry;
  }, []);
  return schemeIds?.concat(schemeGroupIds) ?? [];
};
